import styled, { css } from 'styled-components';
import { font } from "../../lib/sharedStyles";

export const ArrowWrapper = styled.div`
  display: none;
  pointer-events: none;
  position: absolute;
  bottom: 20px;
  right: 20px;
  justify-content: center;
  align-items: center;
  z-index: 10;
  transition: opacity 0.3s ease;
  border-radius: 50%;
  background: #fff;
  opacity: 0;

  svg {
    transition: transform 0.3s ease;
  }
  
  @media (min-width: 1024px) {
    display: flex;
  }
`;
  
interface RootContainerProps {
  $alignment: string; 
  $cursor: string;
  $isContentInGrid: boolean;
}
export const RootContainer = styled.div<RootContainerProps>`
  display: flex;
  ${({ $cursor }) => `cursor: ${$cursor}`};

  ${({ $alignment }) => $alignment == 'center' && `
    justify-content: center;
  `}

  ${({ $alignment }) => $alignment == 'right' && `
    justify-content: flex-end;
  `}

  ${({ $isContentInGrid }) => $isContentInGrid && `
    height: 100%;
  `}
`;

interface ComponentContainerProps {
  $fullWidth: boolean;
  $marginBottom?: number;
  $marginTop?: number;
  $maxWidth?: number;
  $style: string;
  $theme?: string;
}
export const ComponentContainer = styled.div<ComponentContainerProps>`
  position: relative;
  z-index: 1;
  overflow: hidden;

  ${({ $maxWidth }) => $maxWidth != undefined && `
    max-width: ${$maxWidth}px;
  `}

  ${({ $marginTop }) => $marginTop != undefined && `
    margin-top: ${$marginTop}px;
  `}

  ${({ $marginBottom }) => $marginBottom != undefined && `
    margin-bottom: ${$marginBottom}px;
  `}

  ${({ $style }) => $style == "Card" && `
    border-radius: 16px;
  `}

  ${({ $fullWidth }) => $fullWidth && `
    width: 100%;
  `}

  &:hover ${ArrowWrapper} {
    opacity: 1;
  }
`;
  
interface DesktopAssetContainerProps {
  $fullHeight: boolean;
  $hideMobile: boolean; 
  $isContentInGrid: boolean;
}
export const DesktopAssetContainer = styled.div<DesktopAssetContainerProps>`
  ${({ $hideMobile }) => $hideMobile && `
    display: none;

    @media (min-width: 768px) {
      display: block;
    }
  `}

  ${({ $fullHeight }) => $fullHeight && `
    height: 100%;

    img {
      height: 100%;
      object-fit: cover;
      object-position: center;
      transition: all 1000ms ease;
    }
  `}

  ${({ $isContentInGrid }) => $isContentInGrid && `
    img {
      position: absolute;
      height: 100%;
      object-fit: cover;
    }
  `}
`;
  
export const MobileAssetContainer = styled.div`
  @media (min-width: 768px) {
    display: none;
  }
`;
  
export const Video = styled.video`
  width: 100%;
  height: auto;
  vertical-align: bottom;
`;

export const Image = styled.img`
  width: 100%;
  max-width: 100%;
  vertical-align: bottom;
`;

export const FenderCTAStyling = css`
  justify-content: left;
  left: 16px;
  bottom: 16px;
  padding: 0px;

  a {
    ${font('Instrument Sans', 500, '16px', '16px')}
    font-style: normal;
    letter-spacing: -0.32px;
    padding: 0px;

    &:hover {
      background: none;
    }
  }

  @media (min-width: 768px) {
    width: 60%;
    max-width: 300px;
  }

  @media (min-width: 1024px) {
    bottom: 20px;
    left: 24px;
    
    a {
      font-size: 24px;
      line-height: 24px;
      letter-spacing: -0.48px;
    }
  }
`;

export const JacksonCTAStyling = css`
  bottom: 20px;
  justify-content: center;
  bottom: 0px;
  justify-content: center;
  padding-bottom: 20px;
  padding-top: 20px;
  background: linear-gradient(to bottom, rgba(0,0,0,0) 0%,rgba(0,0,0,0.85) 100%);

  a {
    color: #fff;
    font-family: Palanquin Dark, sans-serif;
    font-size: 1.25rem;
    font-weight: 700;
    letter-spacing: .125rem;
    line-height: 2rem;
    margin-bottom: 0;
    padding-bottom: .625rem;
    text-transform: uppercase;

    &:after {
      color: #f1f1f1;
      content: "▶";
      font-size: .7rem;
      margin-left: .65rem;
      display: inline;
    }
  }
`;

export const PresonusCTAStyling = css`
  bottom: 40px;
  justify-content: center;

  a {
    font-size: 24px;
    line-height: 28px;
    text-decoration: underline;
  }
`;

export const StyledCTAWrapper = styled.div<{ brand: string; $theme?: string }>`
  position: absolute;
  width: 100%;
  display: flex;

  a {
    border: none;
    background: none;
    text-decoration: none;
    color: ${({ $theme }) => ($theme === 'light' ? '#000' : '#fff')};

    &:after {
      display: none;
    }
        
    &:hover {
      background: none;
    }
  }

  ${(props) =>
    props.brand === 'fender'
      ? FenderCTAStyling
      : props.brand === 'jackson'
      ? JacksonCTAStyling
      : props.brand === 'presonus'
      ? PresonusCTAStyling
      : FenderCTAStyling}
`;

export const FenderEyebrowStyling = css`
  font-family: "Instrument Sans";
  font-weight: 600;
  letter-spacing: -0.02em;
`;

export const JacksonEyebrowStyling = css`
  font-family: 'Palanquin Dark', sans-serif;
`;

export const PresonusEyebrowStyling = css`
  font-family: 'HelveticaNowDisplay';
`;

export const EyebrowContainer = styled.div<{ brand: string; $theme?: string }>`
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 1;
  ${font('Instrument Sans', 600, '14px', '22px')}
  color: ${({ $theme }) => ($theme === 'light' ? '#000' : '#fff')};
  font-style: normal;
  letter-spacing: 0.14px;

  @media (min-width: 1024px) {
    top: 24px;
    left: 24px;
  }

  ${(props) =>
    props.brand === 'fender'
      ? FenderEyebrowStyling
      : props.brand === 'jackson'
      ? JacksonEyebrowStyling
      : props.brand === 'presonus'
      ? PresonusEyebrowStyling
      : FenderEyebrowStyling}
`;
